import React, { useEffect, useState } from "react";

const MarqueeText = () => {
  const items = ["Digital Twins", "Industrial IoT"];
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % items.length);
        setVisible(true);
      }, 350);
    }, 2200);

    return () => clearInterval(cycle);
  }, [items.length]);

  return (
    <div id="text" className="hero-marquee" aria-live="polite">
      <div className={`hero-marquee-item ${visible ? "is-visible" : "is-hidden"}`}>
        {items[index]}
      </div>
    </div>
  );
};

export default MarqueeText;
